import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OvertimeRequest  {
    _originalTypeClassName = "zERP.BO.OvertimeRequest";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OvertimeRequest.translate = translateService;
}
this.Id = null;
this.DateRequested = null;
this.OvertimeDate = null;
this.RequestedHours = null;
this.EmployeeNotes = null;
this.HRNotes = null;
this.Status = null;
this.Type = null;
this.HandledAt = null;
this.From = null;
this.HourFrom = null;
this.MinuteFrom = null;
this.To = null;
this.HourTo = null;
this.MinuteTo = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateRequested:any;
OvertimeDate:any;
RequestedHours:any;
EmployeeNotes:any;
HRNotes:any;
Status:any;
Type:any;
HandledAt:any;
From:any;
HourFrom:any;
MinuteFrom:any;
To:any;
HourTo:any;
MinuteTo:any;
RequestedBy:any;
Assignee:any;
HandledBy:any;
EmployeeContract:any;
OvertimeType:any;
PayrollCalculation:any;
ErganiType:any;
static setRequestedBy = ($this, value) => {
var oldValue = $this.RequestedBy;
$this.RequestedBy = value;
if (value != null) {
}
}
static setAssignee = ($this, value) => {
var oldValue = $this.Assignee;
$this.Assignee = value;
if (value != null) {
}
}
static setHandledBy = ($this, value) => {
var oldValue = $this.HandledBy;
$this.HandledBy = value;
if (value != null) {
}
}
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setOvertimeType = ($this, value) => {
var oldValue = $this.OvertimeType;
$this.OvertimeType = value;
if (value != null) {
}
}
static setPayrollCalculation = ($this, value) => {
var oldValue = $this.PayrollCalculation;
$this.PayrollCalculation = value;
if (value != null) {
}
}
static setErganiType = ($this, value) => {
var oldValue = $this.ErganiType;
$this.ErganiType = value;
if (value != null) {
}
}

static GetFrom($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.HourFrom, () => null)) {return "-";}
let hfrom = Joove.Common.safeNumber($this?.HourFrom) + "";
if (CLMS.Framework.Number.Equal(() => hfrom.length, () => 1)) {hfrom = "0" + hfrom;}
let mFrom = Joove.Common.safeNumber($this?.MinuteFrom) + "";
if (CLMS.Framework.Number.Equal(() => mFrom.length, () => 1)) {mFrom = "0" + mFrom;}
return hfrom + ":" + mFrom;
}
static GetTo($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.HourTo, () => null)) {return "-";}
let hto = Joove.Common.safeNumber($this?.HourTo) + "";
if (CLMS.Framework.Number.Equal(() => hto.length, () => 1)) {hto = "0" + hto;}
let mTo = Joove.Common.safeNumber($this?.MinuteTo) + "";
if (CLMS.Framework.Number.Equal(() => mTo.length, () => 1)) {mTo = "0" + mTo;}
return hto + ":" + mTo;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}